import React from 'react'
// import * as FaIcons from 'react-icons/fa'
// import * as AiIcons from 'react-icons/ai'
import * as IoIcons from 'react-icons/io'
// import * as RiIcons from 'react-icons/ri'
import Theme from '../Theme'

export const SidebarData = [
    {
        title: "My Dashboard",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "dashboard",
        role: "SECURITY,VERIFIER,AUDITOR,QA1,QA2,QA3,APPROVER",
        subNav: [
            {
                title: "Dashboard",
                slug: [ "dashboard", "dashboard" ],
                icon: <IoIcons.IoIosPaper />
            },
        ]
    },
    /* {
        title: "IT Service Provider",
        icon: Theme.FileList,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "it_service_provider",
        subNav: [
            {
                title: "Application Details",
                slug: [ "it_service_provider", "it_application" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Document Verification",
                slug: [ "it_service_provider", "it_document" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Payment Details",
                slug: [ "it_service_provider", "it_payment" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Audit",
                slug: [ "it_service_provider", "audit" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Quality Assurance",
                slug: [ "it_service_provider", "it_assurance" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Approval",
                slug: [ "it_service_provider", "it_approval" ],
                icon: <IoIcons.IoIosPaper />
            },
            // {
            //     title: "Legal Assurance",
            //     slug: [ "it_service_provider", "it_legal" ],
            //     icon: <IoIcons.IoIosPaper />
            // },
            // {
            //     title: "Certificate Management",
            //     slug: [ "it_service_provider", "it_certificate" ],
            //     icon: <IoIcons.IoIosPaper />
            // }
        ]
    }, */
    {
        title: "Certificate Management",
        icon: Theme.FileList,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "certificate_management",
        role: "SECURITY,VERIFIER,AUDITOR,QA1,QA2,QA3,APPROVER",
        subNav: [
            {
                title: "Suspend Certificate",
                slug: [ "certificate_management", "suspend_certificates" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Uplift Suspension",
                slug: [ "certificate_management", "uplift_suspensions" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Application Progress",
                slug: [ "certificate_management", "certificate_progress" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Issued Certificates",
                slug: [ "certificate_management", "issued_certificates" ],
                icon: <IoIcons.IoIosPaper />
            }
        ]
    },
    {
        title: "Reports",
        icon: Theme.BookReaderIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "reports",
        role: "VERIFIER,AUDITOR",
        subNav: [
            {
                title: "Signed Certificates",
                slug: [ "all_signed_certificates", "all_signed_certificates" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Approved by the Manager/DRLS",
                slug: [ "approved_by_manager_report", "approved_by_manager_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Level of Certification",
                slug: [ "certification_levels_report", "certification_levels_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "ISIC Codes",
                slug: [ "isic_codes_report", "isic_codes_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Gender Report",
                slug: [ "per_gender_apps_report", "per_gender_apps_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Renewals vs New",
                slug: [ "renewals_vs_new_applications", "renewals_vs_new_applications" ],
                icon: <IoIcons.IoIosPaper />
            }
        ]
    },
    {
        title: "Reports",
        icon: Theme.BookReaderIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "reports",
        role: "QA1,QA2,QA3,APPROVER",
        subNav: [
            {
                title: "Signed Certificates",
                slug: [ "all_signed_certificates", "all_signed_certificates" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Approved by the Manager/DRLS",
                slug: [ "approved_by_manager_report", "approved_by_manager_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Paid, Not Yet Certified",
                slug: [ "paid_but_not_signed", "paid_but_not_signed" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "About To Expire",
                slug: [ "about_to_expire", "about_to_expire" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Timelines Report",
                slug: [ "timelines_report", "timelines_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Assignments",
                slug: [ "assigned_users_to_applications", "assigned_users_to_applications" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Registrations",
                slug: [ "user_registrations_report", "user_registrations_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "ISIC Codes",
                slug: [ "isic_codes_report", "isic_codes_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Gender Report",
                slug: [ "per_gender_apps_report", "per_gender_apps_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Level of Certification",
                slug: [ "certification_levels_report", "certification_levels_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Renewals vs New",
                slug: [ "renewals_vs_new_applications", "renewals_vs_new_applications" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Audit Reports",
                slug: [ "all_audit_reports", "all_audit_reports" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Renewals",
                slug: [ "renewal_applications_report", "renewal_applications_report" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Districts",
                slug: [ "per_district_apps_report", "per_district_apps_report" ],
                icon: <IoIcons.IoIosPaper />
            },
        ]
    },
    {
        title: "User Management",
        icon: Theme.NewUserIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "reports",
        role: "QA1,QA2,QA3,APPROVER",
        subNav: [
            {
                title: "New User",
                slug: [ "new_admin_user", "new_admin_user" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "All users",
                slug: [ "all_users", "all_users" ],
                icon: <IoIcons.IoIosPaper />
            },
            {
                title: "Applicants",
                slug: [ "all_applicants", "all_applicants" ],
                icon: <IoIcons.IoIosPaper />
            },
        ]
    }
]

export const clientMenu = [
    {
        title: "My Applications",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "welcome"
    }
]